export default "__VITE_ASSET__ebbde1a1__"